import Vue from 'vue'
import Vuex from 'vuex'
import { getAdmin, getToken, setToken, setAdmin, clearAuth } from '@/utils/auth'
import { login as loginApi } from '@/api/admin'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken(),
    admin: getAdmin(),
    sidebarCollapsed: false
  },
  getters: {
    isLoggedIn: state => !!state.token,
    adminName: state => (state.admin && state.admin.nickname) || '管理员',
    isSuperAdmin: state => state.admin && state.admin.role === 'super'
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
    },
    SET_ADMIN(state, admin) {
      state.admin = admin
      setAdmin(admin)
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.admin = null
      clearAuth()
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    }
  },
  actions: {
    async login({ commit }, form) {
      const res = await loginApi(form)
      if (res.code !== 0) {
        throw new Error(res.message || '登录失败')
      }
      commit('SET_TOKEN', res.data.token)
      commit('SET_ADMIN', res.data.admin)
      return res.data
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
})
